import on from '../util/Elements/on'
import { breakpoints } from '../vars'

export default function (Site, $) {
	Site.widget('sticky-sidebar', {
		_create () {
			this.stickySidebar()

			this.calculate = on(
				$(window),
				'load resize scroll',
				() => this.stickySidebar()
			)
		},

		_destroy() {
			this.calculate()
		},

		stickySidebar () {
			const sidebar = document.getElementById('sidebar');
			const heroImg = document.getElementsByClassName("page-hero");
			const footNav = document.getElementsByClassName("next-prev");
			const footer  = document.getElementById('site-footer');
			
			if (document.documentElement.clientWidth > breakpoints.sm.max) {
				let topOffset 		= heroImg[0].clientHeight - 110;
				let footerHeight 	= footNav[0].clientHeight + $(footer).outerHeight() + 20;
				let scrollPos 		= document.body.getBoundingClientRect().top;
				let docHeight 		= $(document).height()
				let sidebarHeight 	= $(sidebar).outerHeight();

				if ( (scrollPos + topOffset) <= 80 ) {
					sidebar.classList.add('fixed')
				} else {
					sidebar.classList.remove('fixed')
				}

				if (docHeight - 100 - footerHeight + scrollPos <= sidebarHeight) {
					$(sidebar).css({
						top: 'auto',
						bottom: footerHeight + 20 - (docHeight + (scrollPos - window.innerHeight))
					});
				} else {
					$(sidebar).removeAttr('style')
				}
			}
		}
	})
}